<template>
  <div>
    <b-row class="my-4">
      <b-col>
        <b-media tag="li">
          <template v-slot:aside>
            <span class="thumbnail pt-3" id="media-wrapper">
              <font-awesome-icon
                class="text-white align-middle"
                icon="users"
                size="2x"
              ></font-awesome-icon>
            </span>
          </template>
          <h5 class="group-title text-left">
            <router-link
              class="text-blue"
              :to="{ name: 'groupView', params: { id: group.id } }"
              title="View the admission rules and all the members"
              v-b-tooltip.hover.right
            >
              {{ getTitle }}
            </router-link>
          </h5>
          <p class="mb-0 text-left">
            <b-row>
              <b-col cols="6" lg="12" md="12" sm="12" xs="12">
                <span
                  class="mr-lg-2"
                  title="Creation date"
                  v-b-tooltip.hover.bottom
                >
                  <font-awesome-icon icon="calendar-alt" />
                  {{ group.created | utcLocalDate }}
                </span>
                <span
                  v-if="isMember"
                  style="margin-right: 10px"
                  title="Owner of the group"
                  v-b-tooltip.hover.bottom
                >
                  <font-awesome-icon icon="user"></font-awesome-icon>
                  {{ group.creator.name }}
                </span>

              </b-col>
            </b-row>
          </p>
        </b-media>
      </b-col>
      <b-col class="d-flex justify-content-end align-items-center">
        <p class="mb-0 text-left">
          <span
            class="mr-lg-3"
            title="Invite users to group"
            style="cursor: pointer"
            @click="showMsgInvite(group.id)"
            v-b-tooltip.hover.top
            v-if="isOwner"
          >
            <font-awesome-icon icon="user-plus" />
          </span>
          <span
            v-if="isOwner"
            class="mr-lg-2"
            title="Edit the Group"
            style="cursor: pointer"
            @click="editGroup(group.id)"
            v-b-tooltip.hover.top
          >
            <a class="text-dark mr-1">
              <font-awesome-icon icon="edit" />
            </a>
          </span>
          <span
            title="Delete this group"
            style="cursor: pointer"
            @click="showMsgDelete(group.id)"
            v-b-tooltip.hover.top
            v-if="isOwner"
          >
            <font-awesome-icon icon="trash-alt" />
          </span>
          <!-- <span
            class="mr-lg-2"
            title="Reply to join requests"
            style="cursor: pointer"
            @click="showMsgAcceptReject(group.id)"
            v-b-tooltip.hover.top
            v-if="isOwner"
          >
            <font-awesome-icon icon="reply" />
          </span> -->

          <span
            class="mr-lg-2"
            style="cursor: pointer"
            @click="showMsgLeave(group.id)"
            v-if="isMember"
          >
            <font-awesome-icon icon="sign-out-alt" class="mr-2" /><b>LEAVE</b>
          </span>
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { eventBus } from "../../main";

export default {
  name: "GroupsMedia",
  data() {
    return {
      UserLogin: this.$store.state.user.login,
    };
  },
  props: {
    group: Object,
    type3: String,
  },
  computed: {
    isOwner: function () {
      if (this.type3 === "OWN") {
        return true;
      } else if (this.type3 === "PUBLIC") {
        return false;
      }
    },
    isCreatedbyOwner: function () {
      if (
        (this.UserLogin === this.group.creator.login && this.type3 === "OWN") ||
        (this.UserLogin !== this.group.creator.login && this.type3 === "PUBLIC")
      ) {
        return true;
      } else {
        return false;
      }
    },
    isMember: function () {
      if (this.type3 === "OWN") {
        return false;
      } else if (this.type3 === "PUBLIC") {
        return true;
      }
    },
    getTitle() {
      let title = this.group.name;
      if (title) {
        return title;
      }
      return "<Untitled>";
    },
  },
  methods: {
    showMsgLeave(groupId) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to leave this group.", {
          title: "Are you sure you want to leave this group?",
          size: "bg",
          buttonSize: "bg",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (this.boxTwo) {
            this.leaveGroup(groupId);
          } else {
          }
        })
        .catch((error) => {
          alert("An error occurred! Please refresh the page." + error);
        });
    },

    showMsgInvite(groupId) {
      eventBus.$emit("sendgroupIDforConsent", groupId);
    },

    showMsgAcceptReject(groupId2) {
      let a = groupId2;
      eventBus.$emit("sendgroupIDforAcceptReject", a);
    },

    showMsgDelete(groupId) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete this group.", {
          title: "Are you sure you want to delete this group?",
          size: "bg",
          buttonSize: "bg",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (this.boxTwo) {
            this.deleteGroup(groupId);
          } else {
          }
        })
        .then(() => {
          // location.reload();
        })
        .catch((error) => {
          alert("An error occurred! Please refresh the page." + error);
        });
    },
    editGroup(groupId){
      this.$router.push({ path: '/workspace/groups/'+groupId +'/edit' })

    },

    deleteGroup: function (groupId) {
      this.$store.dispatch("deleteGroup", groupId) .then( () => {
        this.$router.push({ name: "groups" });
         window.location.reload()

      })

    },
    leaveGroup: function (groupId) {
      this.$store.dispatch("leaveGroup", groupId).then((data) => {
        window.location.reload();
      });
    },
  },
};
</script>

<style scoped>
  #media-wrapper {
    width: 64px;
    height: 64px;
  }
  .media {
    height: 64px;
  }
  .group-title {
    margin-top: 0;
    margin-bottom: 15px;
  }
  .thumbnail {
    background-color: #aeaeae;
  }
</style>



// WEBPACK FOOTER //
// src/components/groups/GroupsMedia.vue